import { DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { Button, ConfigProvider, Flex, Input, Pagination, Switch, TreeSelect } from 'antd';
import { PaginationProps } from 'antd/es/pagination/Pagination';
import viVN from 'antd/locale/vi_VN';
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Layout from '../../../Layout';
import { deleteIProvince, gInfoProvince, gListIProvinceUnit, gListNationwide, IProvince, IProvinceEdit, IProvinceFilter, updateStatusIProvince } from '../../../api/provinces/provincesApi';
import * as selectOptionsApi from '../../../api/selectOptions/selectOptionsApi';
import { activeArray, convertNationwideTree } from '../../../api/unit/unitApi';
import BreadcrumbBlock from '../../../components/BreadcrumbBlock/BreadcrumbBlock';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import { NodataTable } from '../../../components/NoDataTable';
import useDebounce from '../../../hook/useDebounce';
import useLoading from '../../../hook/useLoading';
import useToast from '../../../hook/useToast';
import { OptionSelect_V2 } from '../../../services/fomartUnit';
import { checkDisabledPermission, dataPagination, flattenDonViArray, getUserPermissions } from '../../../until';
import DrawerAddvance from '../../VehicleManagement/VehicleList/Component/Drawer/DrawerAddvance';
import { ModalAddProvince } from './Modal/ModalAdd';
import { ModalEditProvince } from './Modal/ModalEdit';
import { useSelector } from 'react-redux';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { formatNumber } from '../../../services/mixin';

interface TableDataType {
  key: React.Key;
  codeprovince: string;
  name: string;
  nameunit: string;
  region: string;
  nationwide: string;
  status: number;
}

const Province: React.FC = () => {
  useEffect(() => {
    getListIProvince()
  }, [])
  const pushToast = useToast();
  const pushLoading = useLoading();
  const location = useLocation();
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, } = getUserPermissions(permissionSlice, location.pathname)

  const [listProvince, setListProvince] = useState<TableDataType[]>([]);
  const [dataListNationwide, setDataListNationwide] = useState<OptionSelect_V2[]>([]);
  const [dataListNationwideDetail, setDataListNationwidDetail] = useState<OptionSelect_V2[]>([]);
  const [dataConvert, setDataConvert] = useState<selectOptionsApi.dataConvert[]>([]);
  const [inForProvince, setInForProvince] = useState<IProvinceEdit>();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModalProvince, setShowDeleteModalProvince] = useState(false);
  const [isOpenAddvance, setIsOpenAddvance] = useState(false);
  const [idProvince, setIdProvince] = useState<number>();
  const [defaulFilter, setDefaultFilter] = useState<IProvinceFilter>();

  // Initialize columns as state
  let columnDefs = useMemo<ColDef<any>[]>(() =>
    [
      {
        headerName: 'Hành động',
        field: 'action',
        colId: 'action',
        width: 180, // Width cố định cho cột Hành động
        resizable: false,
        suppressMovable: true,
        lockPosition: 'left',

        headerComponentParams: {
          template: '<span class="w-full flex items-center justify-center">Hành động</span>'
        },
        cellRenderer: (params: ICellRendererParams) => {
          const { key } = params.data;
          return (
            <div className="h-full d-flex  align-center justify-center gap-10-px">
              <EditOutlined
                className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer   ${checkDisabledPermission(edit)}`}
                onClick={() => getinforProvince(Number(key))}
              />
              <DeleteOutlined
                className={`text-F5222D text-sm border-EAECF0 p-5-px bg-white rounded-2 cursor-pointer   ${checkDisabledPermission(isdelete)}`}
                onClick={() => openModalDeleteProvince(Number(key))}
              />
            </div>

          );
        }
      },
      {
        headerName: 'Mã tỉnh thành',
        field: 'codeprovince',
        colId: 'codeprovince',
        flex: 1, // Các cột khác dùng flex
        minWidth: 100 // Đảm bảo cột không quá nhỏ
      },
      {
        headerName: 'Tên tỉnh thành',
        field: 'name',
        colId: 'name',
        flex: 1,
        minWidth: 100
      },
      {
        headerName: 'Tên đơn vị',
        field: 'nameunit',
        colId: 'nameunit',
        flex: 1,
        minWidth: 100
      },
      {
        headerName: 'Vùng miền',
        field: 'region',
        colId: 'region',
        flex: 1,
        minWidth: 100
      },
      {
        headerName: 'Toàn quốc',
        field: 'nationwide',
        colId: 'nationwide',
        flex: 1,
        minWidth: 100
      },
      {
        headerName: 'Trạng thái',
        field: 'status',
        colId: 'status',
        flex: 1,
        minWidth: 175, // Giữ chiều rộng tối thiểu cho cột trạng thái
        cellRenderer: (params: ICellRendererParams) => {
          const { key, status } = params.data;
          return (
            <div className="d-flex align-center gap-10-px white-space-nowrap">
              <Switch
                defaultChecked={!!status}
                onChange={() => updateActiveProvince(Number(key))}
                className={`rs-switch rs-switch--sm   ${checkDisabledPermission(edit)}`}
              />
              <p className="font-medium fw-500 text-344054">
                {activeArray[status ? 1 : 0]}
              </p>
            </div>
          );
        }
      }
    ], [pagination]);

  const defaultColumnsShow = ['action', 'codeprovince', 'name', 'nameunit', 'region', 'nationwide', 'status'] as any;

  // const gListNationwide = async () => {
  //   const result = await selectOptionsApi.getListNationwide();
  //   if (result?.status) {
  //     setDataListNationwide(convertNationwideTree(result.data));
  //     setDataConvert(flattenDonViArray(result.data));
  //   } else {
  //     pushToast(result?.message, 'error', 2000);
  //   }
  // };

  const getListIProvinceUnit = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true);
    const result = await gListIProvinceUnit(pageSize, pageCurent, defaulFilter?.search, defaulFilter?.listUnit);
    if (result?.status) {
      setListProvince(convertData(result.data));
      setPagination({ current: pageCurent, total: result.total, pageSize });
    } else {
      pushToast(result?.message, 'error', 2000);
    }
    pushLoading(false);
  }, 500);

  const getListIProvince = useDebounce(async () => {
    pushLoading(true);
    const result = await gListNationwide();
    if (result?.status) {

      setDataListNationwide(convertNationwideTree(result.data));
    } else {
      pushToast(result?.message, 'error', 2000);
    }
    pushLoading(false);
  }, 500);


  const convertData = (data: IProvince[]) => {
    const convertData = data.map((item) => ({
      key: item.id,
      codeprovince: item.code,
      name: item.title,
      nameunit: item.unitTitle,
      region: item.regionTitle,
      nationwide: item.nationwideTitle,
      status: item.view,
    }));
    return convertData;
  };

  const getinforProvince = async (id: number) => {
    const result = await gInfoProvince(id);
    if (result?.status) {
      setShowEditModal(true);
      setInForProvince(result?.data);
    } else {
      pushToast(result?.message, 'warning', 2000);
    }
  };

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }));
    getListIProvinceUnit(pageNumber, pageSize);
  };

  const onSubmitFormModalAdd = (isSuccess: boolean, message?: string) => {
    if (isSuccess) {
      pushToast(message, 'success', 2000);
      setShowAddModal(false);
      getListIProvinceUnit(pagination.current, pagination.pageSize);
    } else {
      pushToast(message, 'warning', 2000);
    }
  };

  const onSubmitFormModalEdit = (isSuccess: boolean, message?: string) => {
    if (isSuccess) {
      pushToast(message, 'success', 2000);
      setShowEditModal(false);
      getListIProvinceUnit(pagination.current, pagination.pageSize);
    } else {
      pushToast(message, 'warning', 2000);
    }
  };

  const openModalDeleteProvince = (id: number) => {
    setShowDeleteModalProvince(true);
    setIdProvince(id);
  };

  const closeModalDeleteProvince = () => {
    setShowDeleteModalProvince(false);
    setIdProvince(undefined);
  };

  const confirmDelete = async () => {
    const result = await deleteIProvince(Number(idProvince));
    if (result?.status) {
      pushToast(result?.message, 'success', 2000);
      closeModalDeleteProvince();
      getListIProvinceUnit(pagination.current, pagination.pageSize);
    } else {
      pushToast(result?.message, 'warning', 2000);
    }
  };

  const updateActiveProvince = async (id: number) => {
    const result = await updateStatusIProvince(id);
    if (result?.status) {
      getListIProvinceUnit(pagination.current, pagination.pageSize);
      pushToast(result.message, 'success', 2000);
    } else {
      pushToast(result?.message, 'error', 2000);
    }
  };

  const checkedList = localStorage.getItem('provinceListColums')
    ? JSON.parse(localStorage.getItem('provinceListColums') as string)
    : [...defaultColumnsShow];

  // Sử dụng colId thay vì key
  const columnDefsWithVisibility = useMemo(() => {
    return columnDefs.map((item: any) => ({
      ...item,
      hide: !checkedList.includes(item.colId) // Sử dụng hide property của AG Grid
    }));
  }, [columnDefs, checkedList]);

  const handleCloseSetting = (value: any, isChange: boolean, reorderedColumns: any[]) => {
    if (isChange) {
      localStorage.setItem('provinceListColums', JSON.stringify(value));
      const updatedColumns = reorderedColumns.map((col) => ({
        ...col,
        hidden: !value.includes(col.colId),
      }));
      // setColumnDefs(updatedColumns);
      columnDefs = updatedColumns
    }
    setIsOpenAddvance(false);
  };

  useEffect(() => {
    getListIProvinceUnit();
  }, [defaulFilter]);

  return (
    <>
      <ModalAddProvince
        isOpen={showAddModal}
        dataListNationwide={dataListNationwide}
        onSubmitFormModalAdd={onSubmitFormModalAdd}
        onClose={() => setShowAddModal(false)}
      />
      <ModalEditProvince
        isOpen={showEditModal}
        dataListNationwide={dataListNationwide}
        inForProvince={inForProvince}
        onSubmitFormModalEdit={onSubmitFormModalEdit}
        onClose={() => setShowEditModal(false)}
      />
      <ModalDeleteManager
        isOpen={showDeleteModalProvince}
        title="Xóa tỉnh thành"
        titleDelete="Xóa"
        content="Tỉnh thành và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục"
        closeModal={closeModalDeleteProvince}
        onConfirm={confirmDelete}
      />
      <DrawerAddvance
        isOpen={isOpenAddvance}
        columns={columnDefs}
        defaultColumnsShow={defaultColumnsShow}
        localStorageValue="provinceListColums"
        onClose={(value, isChange, reorderedColumns) => handleCloseSetting(value, isChange, reorderedColumns)}
        closeDrawer={() => setIsOpenAddvance(!isOpenAddvance)}
      />
      <Layout className="customer-hobby">
        <BreadcrumbBlock
          items={[
            { title: <Link to="/">THACO AUTO CRM</Link> },
            { title: 'Danh mục đơn vị' },
            { title: 'Tỉnh thành' },
          ]}
          title="Tỉnh thành"
          className="gutter-block-end"
        />
        <Flex vertical className="gap-18px">
          <Flex align="center" className="gap-10px">
            <span className="fsz-16 font-medium text-nowrap">Danh sách tỉnh thành</span>
            <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-1 h-8 justify-between overflow-hidden">
              <Input
                placeholder="Tìm kiếm"
                className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
                value={defaulFilter?.search}
                onChange={(e: any) => setDefaultFilter({ ...defaulFilter, search: e.target.value })}
              />
              <div className="border-l-F2F4F7 h-full d-flex align-center">
                <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
              </div>
            </div>
            <div className="w-500-px">
              <TreeSelect
                showSearch
                value={defaulFilter?.listUnit}
                placeholder="Chọn đơn vị"
                allowClear
                multiple
                treeCheckable
                treeDefaultExpandAll={false}
                treeCheckStrictly
                onChange={(e: any) => setDefaultFilter({ ...defaulFilter, listUnit: e.map((item: any) => item.value) })}
                treeData={dataListNationwide}
                className="custom-tree-select-V2 w-full"
                filterTreeNode={(input: string, option: any) =>
                  typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }

              />
            </div>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              className={`rs-button rs-button--sm   ${checkDisabledPermission(add)}`}
              onClick={() => setShowAddModal(true)}
            >
              Tạo mới
            </Button>
            <button
              className="border-EAECF0 bg-white rounded-2 w-8 h-8 shadow-btn-save"
              onClick={() => setIsOpenAddvance(true)}
            >
              <SettingOutlined className="text-sm text-344054" />
            </button>
          </Flex>



          <div className={`order-history-card__body `}>
            <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
              <AgGridReact
                className="my-auto-height-grid"
                getRowStyle={(params: any) => ({
                  backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                })}
                rowData={listProvince}
                rowHeight={55}
                columnDefs={columnDefsWithVisibility}
                rowSelection={{ mode: 'multiRow' }}
                // rowSelection="multiple"
                overlayNoRowsTemplate={NodataTable}
                suppressDragLeaveHidesColumns={true}
              />

            </div>
            <ConfigProvider locale={viVN}>
              <div className="pagination-block">
                <Pagination showSizeChanger current={pagination.current} pageSize={pagination.pageSize} total={pagination.total}
                  itemRender={(page, type, originalElement) => {
                    // Chỉ custom khi là nút số trang
                    if (type === 'page') {
                      return <span>{formatNumber(page)}</span>;
                    }
                    // prev / next / jump-prev / jump-next giữ nguyên
                    return originalElement;
                  }}
                  showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize,
                    pagination.current).totalPage} trang`}
                  className='rs-pagination'
                  onChange={onPaginationChange}
                />
              </div>
            </ConfigProvider>
          </div>
        </Flex>
      </Layout>
    </>
  );
};

export default Province;
